// Live tokenized-MSFT market data for MSFT.exe + the tray chip.
// Source: DexScreener public API (browser-safe). Chain-derived numbers only —
// nothing here is hand-written. Falls back to the last good reading (localStorage)
// and finally to `null`, which the UI renders as NO SIGNAL.

export const MSFT = '0xe93237C50D904957Cf27E7B1133b510C669c2e74'; // Microsoft • Robinhood Token (official RWA, admin-verified)
export const CHAIN_ID = 4663;
export const RPC = 'https://rpc.mainnet.chain.robinhood.com';
export const EXPLORER = 'https://robinhoodchain.blockscout.com';
export const DS_TOKEN = `https://api.dexscreener.com/latest/dex/tokens/${MSFT}`;

const KEY = 'ic:msft:v1';
const STABLE = /^(USDG|USDC|USDT|DAI)$/i;
let inflight = null;

function readCache() {
  try {
    const c = JSON.parse(localStorage.getItem(KEY) || 'null');
    return c && typeof c.price === 'number' ? { ...c, stale: true } : null;
  } catch (e) {
    return null;
  }
}

export async function fetchMsft() {
  if (inflight) return inflight;
  inflight = (async () => {
    try {
      const r = await fetch(DS_TOKEN, { cache: 'no-store' });
      if (!r.ok) throw new Error(`ds ${r.status}`);
      const d = await r.json();
      const all = (d && d.pairs) || [];
      const rh = all.filter(p => p.chainId === 'robinhood');
      // Price = deepest MSFT/stable pool (MSFT as base).
      const priced = rh
        .filter(
          p =>
            p.baseToken &&
            p.baseToken.address.toLowerCase() === MSFT.toLowerCase() &&
            STABLE.test(p.quoteToken.symbol),
        )
        .sort((a, b) => (b.liquidity?.usd || 0) - (a.liquidity?.usd || 0));
      const p = priced[0];
      if (!p) throw new Error('no MSFT/stable pool');
      // The meta, counted live: how many tokens on 4663 are QUOTED in MSFT.
      const quotedIn = rh.filter(
        q => q.quoteToken && q.quoteToken.address.toLowerCase() === MSFT.toLowerCase(),
      );
      const out = {
        price: Number(p.priceUsd),
        chg24: p.priceChange ? Number(p.priceChange.h24) : null,
        liq: Number(p.liquidity?.usd || 0),
        vol24: Number(p.volume?.h24 || 0),
        quote: p.quoteToken.symbol,
        quoteAddress: p.quoteToken.address,
        pair: p.pairAddress,
        pairUrl: p.url,
        dex: p.dexId,
        quotedInCount: quotedIn.length,
        quotedInVol24: quotedIn.reduce((s, q) => s + Number(q.volume?.h24 || 0), 0),
        at: Date.now(),
        stale: false,
      };
      try {
        localStorage.setItem(KEY, JSON.stringify(out));
      } catch (e) {
        /* private mode */
      }
      return out;
    } catch (e) {
      return readCache();
    } finally {
      inflight = null;
    }
  })();
  return inflight;
}

export const fmtUsd = (n, d = 2) =>
  typeof n === 'number' && isFinite(n)
    ? '$' + n.toLocaleString('en-US', { maximumFractionDigits: d, minimumFractionDigits: d })
    : '——';
export const fmtCompact = n =>
  typeof n === 'number' && isFinite(n)
    ? '$' + Intl.NumberFormat('en-US', { notation: 'compact', maximumFractionDigits: 1 }).format(n)
    : '——';
export const short = a => (a ? `${a.slice(0, 6)}…${a.slice(-4)}` : '——');
